module.exports = __webpack_public_path__ + "media/images/weather/21_day_g-232e7ca73d11e61c342d47f28e7ca8d8.png";